import { IcoCheck } from 'icone';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface PeriodicReportingStatusCellProps {
	value: number;
}

const PeriodicReportingStatusCell: React.FC<PeriodicReportingStatusCellProps> = ({ value }) => {
	const fill = value === 1 ? '#D4BE31' : '#689689';
	const text = value === 1 ? 'Da sanare' : 'Rendicontabile';
	return (
		<OverlayTrigger placement="top" overlay={(props) => <Tooltip {...props}>{text}</Tooltip>}>
			<IcoCheck style={{ fill }} />
		</OverlayTrigger>
	);
};

export default PeriodicReportingStatusCell;
